/// <amd-module name="Artifacts/Package/components/PackageDetailsHub" />
import { PackageDetailsTabManager } from "Artifacts/Package/containers/PackageDetailsTabManager";
import { DefaultLoader } from "Artifacts/Root/components/DefaultLoader";
import { decodeName, decodeVersion } from "Artifacts/Root/helpers/PackageDecoderHelper";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { useDecodedURIParams } from "Artifacts/Root/routing/Hooks";
import { IPackageDetailsContainerRouteParams } from "Artifacts/Root/routing/Types";
import * as React from "react";
import { Header } from "VSSUI/Header";
import { Page } from "VSSUI/Page";

interface IPackageDetailsHubProps {
  onBackButton: () => void;
}

const PackageDetailsHub: React.FC<IPackageDetailsHubProps> = ({ onBackButton }) => {
  // Once search upstreams' feature flag is cleaned up, we can move this call back into PackageDetailsTabManager
  const { feed, resolution } = useFeed();

  // Get package identity strings from URL
  const {
    packageName: packageNameFromUrl,
    version: packageVersionFromUrl,
    protocol: protocolFromUrl,
  } = useDecodedURIParams<IPackageDetailsContainerRouteParams>();

  const decodedPackageVersion = packageVersionFromUrl
    ? decodeVersion(packageVersionFromUrl, protocolFromUrl)
    : "";

  const decodedPackageName = packageNameFromUrl
    ? decodeName(packageNameFromUrl, protocolFromUrl)
    : "";

  return (
    <div>
      <Page>
        <Header
          title={`${decodedPackageName} ${decodedPackageVersion}`}
          titleClassName="package-title"
          backButtonProps={{
            onClick: () => onBackButton(),
            ariaLabel: "Back to feed",
          }}
        />
        <DefaultLoader state={resolution}>
          {feed && <PackageDetailsTabManager feed={feed} />}
        </DefaultLoader>
      </Page>
    </div>
  );
};

export { PackageDetailsHub, IPackageDetailsHubProps };
